import { container } from "tsyringe";
import CreativeSourceApi from "api/clapaction/projects/[id]/config/CreativeSourceApi";
import CreativeSourceResponseResource from "common/resources/Project/Config/CreativeSource/CreativeSourceResponseResource";
import CreativeSourceRequestResource from "common/resources/Project/Config/CreativeSource/CreativeSourceRequestResource";
import toValidationError from "utils/toValidationError";

export default class CreativeSourceService {
	private api: CreativeSourceApi = container.resolve(CreativeSourceApi);

	/**
	 * @description Get all by project id
	 */
	public async getAllByProjectId(projectId: string): Promise<CreativeSourceResponseResource[]> {
		return this.api.getAllByProjectId(projectId).catch(toValidationError);
	}

	/**
	 * @description Get one by id
	 */
	public async getById(projectId: string, creativeSourceId: string): Promise<CreativeSourceResponseResource> {
		return this.api.getById(projectId, creativeSourceId).catch(toValidationError);
	}

	/**
	 * @description Download creative source image
	 */
	public async downloadImage(projectId: string, creativeSourceId: string): Promise<Blob> {
		return this.api.downloadImage(projectId, creativeSourceId).catch(toValidationError);
	}

	/**
	 * @description Create a new creative source for a project
	 */
	public async create(projectId: string, request: CreativeSourceRequestResource, image?: File): Promise<CreativeSourceResponseResource> {
		return this.api.create(projectId, request, image).catch(toValidationError);
	}

	/**
	 * @description Update a creative source for a project
	 */
	public async update(projectId: string, creativeSourceId: string, request: CreativeSourceRequestResource, image?: File): Promise<CreativeSourceResponseResource> {
		return this.api.update(projectId, creativeSourceId, request, image).catch(toValidationError);
	}

	/**
	 * @description Delete a creative source for a project
	 */
	public async delete(projectId: string, creativeSourceId: string): Promise<void> {
		return this.api.delete(projectId, creativeSourceId).catch(toValidationError);
	}
}
